import React, { useEffect, useState } from 'react';
import axios from 'axios'
import { ChevronRight, } from 'lucide-react';

import { Link } from 'react-router-dom'
const Footer = () => {
  const [pages, setPages] = useState([])


  useEffect(() => {
    const fetchPages = async () => {
      try {
        const { data } = await axios.get('https://api.jangrabatteries.co.in/api/v1/admin/pages')
        if (data) {
          setPages(data.pages)
        }
      } catch (error) {
        console.log(error)
      }
    }
    fetchPages()
  }, [])

  return (
    <footer className="w-full bg-black text-gray-300">

      {/* TOP FOOTER */}
      <div
        className="bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1503376780353-7e6692767b70')",
        }}
      >
        <div className="bg-black/85 px-6 md:px-10 py-16">
          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

            {/* CONTACT US */}
            <div>
              <h3 className="text-white text-lg font-semibold mb-6">
                CONTACT US
              </h3>

              <ul className="space-y-4 text-sm">
                <li className="flex gap-3">
                  <span className="text-red-500">📍</span>
                  WZ-182, Palam Village, New Delhi – 110045
                </li>
                <li className="flex gap-3">
                  <span className="text-red-500">📞</span>
                  <a href="tel:07861958315"> +91 78619 58315</a>
                </li>
                <li className="flex gap-3">
                  <span className="text-red-500">✉</span>
                  <a href="mailto:support@jangrabatteries.com">support@jangrabatteries.com</a>
                </li>
                <li className="flex gap-3">
                  <span className="text-red-500">🧾</span>
                  GST: 07AANFJ1002E1ZW
                </li>
                <li className="flex gap-3">
                  <span className="text-red-500">⏱</span>
                  Mon – Sun | 10:00 AM – 6:00 PM
                </li>
              </ul>
            </div>

            {/* OUR SERVICES */}
            <div>
              <h3 className="text-white text-lg font-semibold mb-6">
                OUR SERVICES
              </h3>
              <ul className="space-y-3 text-sm">
                <li>Car Battery Replacement</li>
                <li><Link to="/car-batteries">Car Batteries</Link></li>
                <li><Link to="/inverter-Solar-batteries">Inverter & Solar Battery Solutions</Link></li>
                <li><Link to="/old-battery-exchange">Old Battery Exchange</Link></li>
                <li><Link to="/warranty-support">Warrenty Support</Link></li>
              </ul>
            </div>

            {/* CUSTOMER SERVICE */}
            <div>
              <h3 className="text-white text-lg font-semibold mb-6">
                CUSTOMER SERVICE
              </h3>
              <ul className="space-y-3 text-sm">
                <li><Link to="/login">My Account</Link></li>
                <li><Link to="/Cart">Cart</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/shop">Shop</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>

              </ul>
            </div>

            <div className="lg:ml-12">
              <h3 className="text-lg font-semibold text-white mb-6">Policy</h3>
              <ul className="space-y-3">
                {pages.map((link) => (
                  <li key={link._id}>
                    <Link to={`/pages/${link?.slug}`} className="group text-sm flex items-center gap-2 text-white">
                      <span>{link.title}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>


          </div>
        </div>
      </div>

      {/* RED NEWSLETTER BAR */}
      <div className="bg-[#7b0f13] px-6 md:px-10 py-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">

          {/* FOLLOW US */}
          <div className="flex items-center gap-3">
            <span className="text-white font-semibold mr-3">
              FOLLOW US
            </span>
            {["f", "t", "in", "▶"].map((icon, i) => (
              <div
                key={i}
                className="w-9 h-9 bg-white flex items-center justify-center text-black font-semibold cursor-pointer"
              >
                {icon}
              </div>
            ))}
          </div>

          {/* NEWSLETTER */}
          <div className="flex w-full md:w-auto rounded-md">
            <input
              type="email"
              placeholder="Enter your email for offers & updates"
              className="px-4 py-2 w-full md:w-80 text-black outline-none"
            />
            <button className="bg-red-600 px-6 text-white font-semibold ">
              SUBSCRIBE
            </button>
          </div>

        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="bg-black px-6 md:px-10 py-4 flex flex-col md:flex-row items-center justify-between gap-4 text-sm">

        <p className="text-gray-400 text-center md:text-left">
          © {new Date().getFullYear()} Jangra Batteries & Solar Systems LLP.
          All Rights Reserved. Developed by <a href="https://hoverbusinessservices.com/">Hover Business Services LLP.</a>
        </p>

        {/* PAYMENT OPTIONS */}
        <div className="flex items-center gap-3">
          {["Cash", "UPI", "Visa", "MasterCard"].map((p, i) => (
            <div
              key={i}
              className="px-3 py-1 bg-gray-800 text-white text-xs rounded"
            >
              {p}
            </div>
          ))}
        </div>

      </div>

    </footer>
  );
};

export default Footer;
